import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService }  from "../../services/shared.service";
import { IBrandProfile } from '../../interfaces/brand-profile';


@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent  implements OnInit {

  title: string = 'Disbursements';
  message: string = "Are you sure?";
  confirmButtonText: string = "Yes";
  cancelButtonText: string = "Cancel";
  isConfirmButtonVisible: boolean = true;
  isCancelButtonVisible: boolean = true;

  brandProfile!: IBrandProfile;  
  brandStyleTheme: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private sharedService: SharedService,
    ) 
    {
      if (data){
        this.title = data.title || this.title;
        this.message = data.message || this.message;
        if (data.buttonText) {
          this.confirmButtonText = data.buttonText.ok ?? this.confirmButtonText;
          this.cancelButtonText = data.buttonText.cancel ?? this.cancelButtonText;
        }
        if (data.buttonVisible) {
          this.isConfirmButtonVisible = data.buttonVisible.ok ?? this.isConfirmButtonVisible;
          this.isCancelButtonVisible = data.buttonVisible.cancel ?? this.isCancelButtonVisible;
        }
      }
    }

  ngOnInit() {
    // Get the current brand profile
    this.brandProfile = this.sharedService.getBrandProfile();
    if (this.brandProfile) {
      this.brandStyleTheme = this.sharedService.getBrandStyleScheme(this.brandProfile);
    }
  }  

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }  

  onCancelClick(): void {
    this.dialogRef.close(false);
  }  

}
